import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: 14,
    fontWeight: 500,
  },
  viewAllBtn: {
    fontWeight: 500,
    marginRight: 12,
    textTransform: 'inherit',
  },
  versionElement: {
    marginBottom: theme.spacing(2.25),
    cursor: 'pointer',
  },
  versionInfo: {
    marginRight: theme.spacing(2.5),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  loadingContainer: {
    height: 150,
    width: '100%',
  },
  button: {
    fontSize: theme.typography.pxToRem(13),
    marginRight: 12,
    textTransform: 'capitalize',
  },
  versionName: {
    fontSize: theme.typography.pxToRem(13),
    fontWeight: 400,
  },
  versionTitle: {
    color: theme.palette.text.subtitle,
    fontSize: theme.typography.pxToRem(13),
    fontWeight: theme.typography.fontWeightBold,
    maxWidth: 120,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  versionLabel: {
    color: theme.palette.text.subtitle,
    fontSize: theme.typography.pxToRem(13),
    fontWeight: theme.typography.fontWeightBold,
  },
  defaultVersionIcon: {
    color: '#FFB027',
    fontSize: theme.typography.pxToRem(13),
    marginLeft: 10,
    marginRight: 4,
  },
  defaultVersionText: {
    color: '#FFB027',
    fontSize: theme.typography.pxToRem(11),
  },
  emptyPlaceholder: {
    color: theme.palette.text.subtitle,
  },
}));

export default useStyles;
